import { createGlobalStyle } from 'styled-components'
// eslint-disable-next-line import/no-unresolved
import { PancakeTheme } from '@pancakeswap/uikit/dist/theme'

declare module 'styled-components' {
  /* eslint-disable @typescript-eslint/no-empty-interface */
  export interface DefaultTheme extends PancakeTheme {}
}

const GlobalStyle = createGlobalStyle`
  * {
    font-family: 'Kanit', sans-serif;
  }
  body {
    background-color: ${({ theme }) => theme.colors.background};

    img {
      height: auto;
      max-width: 100%;
    }
  }

  a[href^="https://wbescswap.com/swap?outputCurrency=0x91A46Fbf7D7a41f296457c937C782113078700b0"],
  a[href^="https://bescswap.com/swap?outputCurrency=0xf794E0B0c0a91099ccAcac296193e04Fb860442a"] {
    pointer-events: none;
    cursor: default;
  }
`

export default GlobalStyle
